import { CancellationReason as CancellationReasonEnum } from '@mews-commander/data-access';
import { enumify, Enumify } from '@mews/enumify';

function CancellationReason() {}

enumify<CancellationReasonEnum, number>(CancellationReason, 'CancellationReason', {
    Other: 0,
    ConfirmationMissed: 1,
    BookedElsewhere: 2,
    ForceMajeure: 3,
    GuestComplaint: 4,
    NoShow: 5,
    PriceTooHigh: 6,
    ServiceNotAvailable: 7,
    InputError: 8,
    InvalidPayment: 9,
    TravelAgency: 10,
    RequestedByGuest: 11,
    Update: 12,
    BookingAbandoned: 13,
    RequestedByBooker: 14,
});

export default CancellationReason as unknown as Enumify<CancellationReasonEnum, number>;
